import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

function ServiceCard({ service }) {
  const navigate = useNavigate();

  return (
    <motion.article
      className="service-card-premium-v2"
      whileHover={{ y: -8 }}
      transition={{ duration: 0.25 }}
      onClick={() => navigate(`/services/${service.slug}`)}
    >
      <div className="service-card-image-wrapper">
        <img
          src={
            service.heroImage ||
            "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80"
          }
          alt={service.title}
          className="service-card-image"
        />
      </div>

      <div className="service-card-content">
        <span className="service-card-badge">
          Capability
        </span>

        <h3 className="service-card-title-v2">
          {service.title}
        </h3>

        <p className="service-card-description-v2">
          {service.shortDescription}
        </p>

        <div className="service-card-arrow">
          Explore Capability
          <ArrowRight size={18} />
        </div>
      </div>
    </motion.article>
  );
}

export default ServiceCard;